import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import { DotChartOutlined } from '@ant-design/icons';
import SubMenuIndexes from 'modules/layoutModule/enums/SubMenuIndexes';
import MenuIndexes from 'modules/layoutModule/enums/MenuIndexes';
import {
  GardenModulesList,
  GardenSubModuleDefinition,
} from 'enums/modulesDefinition';

const { SubMenu } = Menu;

export const GardenMenuTab = (
  subMenuClick: any,
  setSelectedMenu: any,
  subModulesData: any,
  title: string,
  userModules: any[]
) => {
  const renderSubModules = (el: any) => {
    switch (el.id) {
      case GardenSubModuleDefinition.gardenExpertArticlesAdd:
        return (
          <Menu.Item
            key={MenuIndexes.GARDEN_EXPERT_ARTICLES_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/garden/expert-articles/add">{el.title}</Link>
          </Menu.Item>
        );
      case GardenSubModuleDefinition.gardenExpertArticles:
        return (
          <Menu.Item
            key={MenuIndexes.GARDEN_EXPERT_ARTICLES}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/garden/expert-articles">{el.title}</Link>
          </Menu.Item>
        );
      case GardenSubModuleDefinition.gardenFertilizersAdd:
        return (
          <Menu.Item
            key={MenuIndexes.GARDEN_FERTILIZERS_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/garden/fertilizers/add">{el.title}</Link>
          </Menu.Item>
        );
      case GardenSubModuleDefinition.gardenFertilizers:
        return (
          <Menu.Item
            key={MenuIndexes.GARDEN_FERTILIZERS}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/garden/fertilizers">{el.title}</Link>
          </Menu.Item>
        );
      case GardenSubModuleDefinition.gardenFertilizersDictionary:
        return (
          <Menu.Item
            key={MenuIndexes.GARDEN_FERTILIZERS_DICTIONARY}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/garden/fertilizers-dictionary">{el.title}</Link>
          </Menu.Item>
        );
      default:
        return null;
    }
  };

  const checkPermissions = GardenModulesList.filter((module) => {
    if (userModules.includes(module.id)) return module;
  });

  if (checkPermissions.length === 0) {
    return <></>;
  }

  return (
    <>
      <SubMenu
        icon={<DotChartOutlined />}
        title={title}
        onTitleClick={(e) => subMenuClick(e)}
        key={SubMenuIndexes.GARDEN}
      >
        {checkPermissions.map((module) => renderSubModules(module))}
      </SubMenu>
    </>
  );
};
